import * as React from "react";

export interface ICatalogFilterState {
    item_name?: string;
    sku?: string;
    description?: string;
    category?: string;
    categoryGuid?: string;
    type?: string;
    active?: boolean;
    is_new_release?: boolean;
    is_ready_to_ship?: boolean;
    is_common_item?: boolean;
    qbo_connected?: boolean;
    qbd_connected?: boolean;
    qbo_item_id?: string;
}

export interface ICatalogContext {
    activeProcess: boolean;
    queryString?: string;
    setQueryString?: (queryString: string) => void;
    filterState?: ICatalogFilterState;
    setFilterState?: (filterState: ICatalogFilterState) => void;
}

export const CatalogContext = React.createContext<ICatalogContext>({
    activeProcess: false,
    queryString: undefined,
    setQueryString: undefined,
    filterState: undefined,
    setFilterState: undefined,
});
